import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _AgreementBalance, _CreditProperties, _DocumentAffiliate } from "../../../core/services/dataBean/EntityCatalogVdos";
import { DocumentTemplateEditor } from "../../bpm/config/DocumentTemplateEditor";
import { DocumentTRDEditor } from "../../bpm/config/DocumentTRDEditor";
import { SelectRecurso } from "../../Factoty&Production/LabourType/SelectRecurso";
import { SelectCreditPropertyGroup } from "./SelectCreditPropertyGroup";






export const CreditProperties = () => {

    const CreditProperties = useDataBean(_CreditProperties);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [CreditPropertyGroup, seCreditPropertyGroup] = useState<number>(null)
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [])
    useEffect(() => {
        getLista()

    }, [CreditPropertyGroup])


    const getLista = () => {

        CreditProperties.instance.getCreditPropertyDefinition(null, null, CreditPropertyGroup).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp.List)
                }

            }
        )

    }



    const create = () => {
        CreditProperties.setBean({
            State: 1,
            PropertyType: CreditProperties.bean.PropertyType,
            IDEmployee: single.getAccountID()
            // Since: single.getCurrenDate()
        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        console.log(CreditProperties.bean);
        CreditProperties.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        CreditProperties.instance.deleteCreditProperties(CreditProperties.bean.IDCreditProperties).then(
            (resp) => {
                setModalC({ ...modalC, view: false });
                getLista();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }




    const head = [
        { title: 'ID inforpo', property: 'DefinicionID', visible: true },
        { title: 'Tipo Parametrica', property: 'PropertyType', visible: true },
        { title: 'Valor de la parametrica', property: 'PropertyValue', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: (single.canDelete() && !CreditProperties.bean.DefinicionID), evento: () => { setModalC({ ...modalC, "view": true, name: "Eliminar Propiedad" }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Parametricas Credito">
            <div className="row">
                <div className="col-md-6">
                    <SelectCreditPropertyGroup idSelector={CreditPropertyGroup} onChange={(e) => { seCreditPropertyGroup(e) }} />
                </div>
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={CreditProperties.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <SelectCreditPropertyGroup idSelector={CreditProperties.bean.PropertyType} onChange={(e) => { CreditProperties.setBean({ ...CreditProperties.bean, "PropertyType": e }) }} />
                                </div>

                                <div className="col-md-6">
                                    <label>Tipo parametrica</label>
                                    <input type="text" name="PropertyType" className="form-control" value={CreditProperties.bean.PropertyType} onChange={CreditProperties.handleChange} />
                                </div>

                                <div className="col-md-6">
                                    <label>Valor de la parametrica</label>
                                    <input type="text" name="PropertyValue" className="form-control" value={CreditProperties.bean.PropertyValue} onChange={CreditProperties.handleChange} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <input type="text" name="Description" className="form-control" value={CreditProperties.bean.Description} onChange={CreditProperties.handleChange} />
                                </div>
                            </div>

                        </>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {CreditProperties.bean.Description}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}